/* (c) Copyright Frontify Ltd., all rights reserved. */

export const RESET_FORMATTING_PLUGIN = 'reset-formatting-plugin';
export const ELEMENT_RESET_FORMATTING = 'reset-formatting';
